import { formatCommaNumber } from '@tmap-web-lib/utils'
import dayjs from 'dayjs'

export function tmapDateFormatter(value: string) {
  return dayjs(value, 'YYYYMMDDHHmmss')
}

export function formatTripTimeDiff(tripStartTime: string, tripEndTime: string) {
  const start = tmapDateFormatter(tripStartTime).startOf('minute')
  const end = tmapDateFormatter(tripEndTime).startOf('minute')

  const diffMinutes = end.diff(start, 'minute')
  const hours = Math.floor(diffMinutes / 60)
  const minutes = diffMinutes % 60

  return hours >= 1 ? (minutes ? `${hours}시간 ${minutes}분` : `${hours}시간`) : `${minutes}분`
}

export function formatFloorKilometers(value: number) {
  if (value >= 1000) {
    return `${formatCommaNumber(Number((Math.floor((value / 1000) * 10) / 10).toFixed(1)))}km`
  } else {
    return `${value.toFixed(0)}m`
  }
}

export function formatRoundKilometers(value: number) {
  if (value >= 1000) {
    return formatCommaNumber(Number((Math.round((value / 1000) * 10) / 10).toFixed(1)))
  } else {
    return Number((Math.round((value / 1000) * 10) / 10).toFixed(1))
  }
}

/**
 * 미터 → km 변환 (NumberFlow용 숫자 반환)
 * - 1000m 미만: 미터 단위 정수 반환 (예: 800 → 800)
 * - 1000m 이상: km 변환, 정확히 나누어떨어지면 소수점 없이 (예: 2000 → 2), 아니면 소수점 1자리 (예: 1500 → 1.5)
 */
export function formatDistanceToKm(meters: number) {
  if (meters < 1000) return Math.round(meters)
  const km = Math.round((meters / 1000) * 10) / 10
  return km % 1 === 0 ? km : km
}

export function toUrl(originValue: any): string {
  return typeof originValue === 'string'
    ? originValue
    : originValue?.src ?? originValue?.default?.src ?? originValue?.default ?? ''
}

/**
 * 숫자를 만 단위로 축약 표기
 * 1~9,999: 숫자 그대로 (e.g. 1,283)
 * 10,000 이상: 만 단위 축약 (e.g. 1만, 2.3만, 45.6만)
 */
export function formatCount(value: number): string {
  if (value < 10000) {
    return formatCommaNumber(value)
  }
  const man = value / 10000
  const formatted = man % 1 === 0 ? `${man}` : `${Math.floor(man * 10) / 10}`
  return `${formatted}만`
}
